(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mm-before-after')) {
  customElements.define('mm-before-after', class extends HTMLElement {
    connectedCallback() {
      this.updateViewport = () => {
        this.style.setProperty('--mm-ba-viewport', `${document.documentElement.clientWidth}px`);
      };
      this.updateViewport();
      window.addEventListener('resize', this.updateViewport);
      if ('ResizeObserver' in window) {
        this.viewportObserver = new ResizeObserver(this.updateViewport);
        this.viewportObserver.observe(document.documentElement);
      }
      this.range = this.querySelector('.mm-ba__range');
      if (!this.range) return;
      this.update = () => {
        this.style.setProperty('--mm-ba-position', `${this.range.value}%`);
      };
      this.range.addEventListener('input', this.update);
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.updateViewport);
      this.viewportObserver?.disconnect();
      this.range?.removeEventListener('input', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-catalog-filters"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-catalog-filters'))customElements.define('mm-catalog-filters',class extends HTMLElement{
 connectedCallback(){this.details=this.querySelector('details');if(!this.details)return;this.media=matchMedia('(min-width:750px)');this.resize=()=>{this.details.open=this.media.matches||this.dataset.hasActive==='true';};this.resize();this.media.addEventListener('change',this.resize);}
 disconnectedCallback(){this.media?.removeEventListener('change',this.resize);}
});
document.addEventListener('click',event=>{const link=event.target.closest('.mm-filter a');if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;const url=new URL(link.href);const params=new URLSearchParams(location.search);params.delete('page');url.search=params.toString();link.href=url.toString();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-collection-budget"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-collection-budget'))customElements.define('mm-collection-budget',class extends HTMLElement{
 connectedCallback(){this.form=this.querySelector('form');this.submit=()=>{const url=new URL(location.href);const sort=this.form.querySelector('[name="sort_by"]');sort.value=url.searchParams.get('sort_by')||sort.value;};this.form.addEventListener('submit',this.submit);}
 disconnectedCallback(){this.form?.removeEventListener('submit',this.submit);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-banner"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-home-banner'))customElements.define('mm-home-banner',class extends HTMLElement{
 connectedCallback(){this.videos=Array.from(this.querySelectorAll('video'));if(!this.videos.length)return;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.mobile=matchMedia('(max-width:767px)');this.change=()=>this.sync();this.mobile.addEventListener('change',this.change);this.motion.addEventListener('change',this.change);this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.1});this.observer.observe(this);}
 sync(){const selected=this.videos.find(v=>getComputedStyle(v.parentElement).display!=='none');this.videos.forEach(v=>{if(v!==selected||this.dataset.autoplay!=='true'||this.motion.matches||!this.visible)v.pause();else v.play().catch(()=>{});});}
 disconnectedCallback(){this.observer?.disconnect();this.videos?.forEach(v=>v.pause());this.mobile?.removeEventListener('change',this.change);this.motion?.removeEventListener('change',this.change);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-collections"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-home-collections'))customElements.define('mm-home-collections',class extends HTMLElement{
 connectedCallback(){this.lastTouch=0;this.touch=()=>{this.lastTouch=Date.now();};this.click=event=>{const tile=event.target.closest('a.mm-collections__tile');if(!tile||this.dataset.tapZoom!=='true'||event.detail===0||event.ctrlKey||event.metaKey||event.shiftKey)return;const touch=matchMedia('(max-width:767px)').matches&&(matchMedia('(hover:none)').matches||Date.now()-this.lastTouch<1500);if(!touch)return;if(!tile.classList.contains('is-expanded')){event.preventDefault();this.querySelectorAll('.is-expanded').forEach(t=>t.classList.remove('is-expanded'));tile.classList.add('is-expanded');}};this.addEventListener('touchstart',this.touch,{passive:true});this.addEventListener('click',this.click);}
 disconnectedCallback(){this.removeEventListener('touchstart',this.touch);this.removeEventListener('click',this.click);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-pose-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mm-pose-video')) {
    customElements.define('mm-pose-video', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-pose-panel]'));
        this.onClick = event => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.tabs.includes(tab)) this.select(tab.getAttribute('aria-controls'));
        };
        this.onKey = event => {
          const current = this.tabs.indexOf(event.target);
          if (current < 0) return;
          let next = current;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          next = (next + this.tabs.length) % this.tabs.length;
          const tab = this.tabs[next];
          this.select(tab.getAttribute('aria-controls'));
          tab.focus();
        };
        this.onBlockSelect = event => {
          const panel = this.panels.find(item => item.dataset.blockId === event.detail?.blockId);
          if (panel) this.select(panel.id);
        };
        this.onVisibility = () => {
          if (document.hidden) this.pauseAll();
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.select(this.dataset.initialPanel);
        this.setAttribute('data-enhanced', '');
      }

      select(id) {
        const active = this.panels.find(panel => panel.id === id) || this.panels[0];
        if (!active) return;
        this.panels.forEach(panel => {
          const selected = panel === active;
          if (!selected) panel.querySelectorAll('video').forEach(video => video.pause());
          panel.hidden = !selected;
        });
        this.tabs.forEach(tab => {
          const selected = tab.getAttribute('aria-controls') === active.id;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
      }

      pauseAll() {
        this.querySelectorAll('video').forEach(video => video.pause());
      }

      disconnectedCallback() {
        this.pauseAll();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
